class QuickFactOverlay extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const infoButton = this.querySelector(".info-button");
    const closeButton = this.querySelector(".close-button");
    this.overlay = this.querySelector(".overlay");
    infoButton.addEventListener("click", () => {
      this.open();
    });
    closeButton.addEventListener("click", () => {
      this.close();
    });
  }
  open = () => {
    this.overlay.classList.remove("hidden");
  };
  close = () => {
    this.overlay.classList.add("hidden");
  };
  disconnectedCallback() {}
}
customElements.define("quick-fact-overlay", QuickFactOverlay);
